import { SearchTerm } from "./SearchTerm";

const SecurityPoliciesSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name",
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "profileSubType.trnName",
        translationKey: "type",
    },
];

export default SecurityPoliciesSearch;
